import React from 'react';
import ZoneIntervention from '../components/ZoneIntervention';
import { ZONES_SEO } from '../seo/pagesSeo';

function Zone93() {
    const seo = ZONES_SEO['93'];
     const cities = [
        "Antiquaire Aubervilliers (93300)",
        "Antiquaire Aulnay-sous-Bois (93600)",

        "Antiquaire Bagnolet (93170)",
        "Antiquaire Bobigny (93000)",
        "Antiquaire Bondy (93140)",

        "Antiquaire Clichy-sous-Bois (93390)",
        "Antiquaire Coubron (93470)",

        "Antiquaire Drancy (93700)",
        "Antiquaire Dugny (93440)",

        "Antiquaire Épinay-sur-Seine (93800)",

        "Antiquaire Gagny (93220)",
        "Antiquaire Gournay-sur-Marne (93460)",

        "Antiquaire L’Île-Saint-Denis (93450)",
        "Antiquaire La Courneuve (93120)",
        "Antiquaire Le Blanc-Mesnil (93150)",
        "Antiquaire Le Bourget (93350)",
        "Antiquaire Le Pré-Saint-Gervais (93310)",
        "Antiquaire Le Raincy (93340)",
        "Antiquaire Les Lilas (93260)",
        "Antiquaire Les Pavillons-sous-Bois (93320)",
        "Antiquaire Livry-Gargan (93190)",

        "Antiquaire Montfermeil (93370)",
        "Antiquaire Montreuil (93100)",

        "Antiquaire Neuilly-Plaisance (93360)",
        "Antiquaire Neuilly-sur-Marne (93330)",
        "Antiquaire Noisy-le-Grand (93160)",
        "Antiquaire Noisy-le-Sec (93130)",

        "Antiquaire Pantin (93500)",
        "Antiquaire Pierrefitte-sur-Seine (93380)",

        "Antiquaire Romainville (93230)",
        "Antiquaire Rosny-sous-Bois (93110)",

        "Antiquaire Saint-Denis (93200)",
        "Antiquaire Saint-Ouen-sur-Seine (93400)",
        "Antiquaire Sevran (93270)",
        "Antiquaire Stains (93240)",

        "Antiquaire Tremblay-en-France (93290)",

        "Antiquaire Vaujours (93410)",
        "Antiquaire Villemomble (93250)",
        "Antiquaire Villepinte (93420)",
        "Antiquaire Villetaneuse (93430)"
    ];
    return <ZoneIntervention departmentName="Seine-Saint-Denis (93)" cities={cities} seoTitle={seo.title} seoDescription={seo.description} seoPath={seo.path} />;
}

export default Zone93;
